import ApiKeyCodeViewComponent from "../Components/ApiKeyCodeViewComponent";
import { AccordionDataCopy } from "../ApiDocuentation/ApiDocStaticDataCopy";
// import ApiKeyAccordians from "../Components/ApiKeyAccordians";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useHistory, useLocation,Link } from "react-router-dom";
import Loader from "../Loader";
import { useInView } from 'react-intersection-observer';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
const ApiKeyAccordians = ({accordData,senderFun,activeSection,setActiveSection}) => {
  
  const observerRef = useRef();

  const location = useLocation();
  const history = useHistory();
  const [expandedAccordion, setExpandedAccordion] = useState(accordData.map(accordion => accordion.id));
  const handleIntersection = (entries) => {
    console.log('entries',entries)
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setActiveSection(entry.target.id);
      }
    });
  };
  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px',
      threshold: 0.5,
    });
  
    observerRef.current = observer;
  
    accordData.map((accordion) => {
      accordion.details.forEach((section) => {
        const target = document.getElementById(section.text.toLowerCase().replace(/\s+/g, "-"));
        if (target) {
          observer.observe(target);
        }
      });
    });
  
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [accordData]);
  return (
    <div style={{
      position:'sticky',
      top:0,
    }}>
    {accordData.map((accordion) => (
      <Accordion
        disableGutters={true}
        key={accordion.id}
        sx={{backgroundColor:'#52617D',color:'#fff'}}
        expanded={expandedAccordion.includes(accordion.id)}
        onChange={() => {
          setExpandedAccordion((prevExpanded) => (
            prevExpanded.includes(accordion.id)
              ? prevExpanded.filter(id => id !== accordion.id)
              : [...prevExpanded, accordion.id]
          ));
        }}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
              sx={{
                transform: "rotate(-90deg)",
                transition: "transform 0.3s ease-in-out",
                color:'#FFFFFF'
              }}

            />
          }
          aria-controls={`panel-content-${accordion.id}`}
          id={`panel-${accordion.id}-header`}
        >
          <Typography style={{color:'#FFF'}}>{accordion.title}</Typography>
        </AccordionSummary>
        <AccordionDetails style={{display:'flex',flexDirection:'column',gap:'3px',backgroundColor:'#F3F6FC'}}>
          {accordion.details.map((accordionDetails) => (
            <div key={accordionDetails.id} style={{borderLeft:`${accordionDetails.text.toLowerCase().replace(/\s+/g, "-") === activeSection ? "#fc9630" : 'transparent'} 2px solid`,paddingLeft:'4px'}} >
                <Link
              
              to={`/api/documentation/${accordionDetails.text.toLowerCase().replace(/\s+/g, "-")}`}
              style={{color:accordionDetails.text.toLowerCase().replace(/\s+/g, "-") === activeSection?'#1c485f':'black',textDecoration:'none'}}
            >
              {accordionDetails.text}
            </Link>
            </div>
          //   <li key={accordionDetails.id}>
          //     {console.log('jabbbbbaaaa',accordionDetails.text,activeSection)}
            // <a
            //   href={`#${accordionDetails.text.toLowerCase().replace(/\s+/g, "-")}`}
            //   style={{color:accordionDetails.text.toLowerCase().replace(/\s+/g, "-") === activeSection?'red':'black'}}
            // >
            //   {accordionDetails.text}
            // </a>
          // </li>
          ))}
        </AccordionDetails>
      </Accordion>
    ))}
    </div>
  )
}
const ApiDocumentation = () => {
  const [activeSection, setActiveSection] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const parentRef = useRef(null);
  const [accordData,setAccordData] = useState(AccordionDataCopy);
  const containerRef = useRef(null);
  const [scrollToSectionTitle, setScrollToSectionTitle] =
    useState("test-your-api-key");
  const [showLoading, setShowLoading] = useState(true);
  const { ref:sectionRef, inView:sectionView, entry } = useInView({
    threshold: 0,
  }); 
  // console.log('is section is visible',sectionView)
  // console.log('is section entry',entry)

  useEffect(() => {
    setTimeout(() => {
      setShowLoading(false);
    }, 3000);
  }, []);

  const handleCatchTitle = (sectionTitle) => {
    setScrollToSectionTitle(sectionTitle);
  };
  const sectionRefs = useRef({});

  const handleRef = (id, ref) => {
    // console.log('handle refs',ref)
    sectionRefs.current[id] = ref;
    // console.log('handle ids',id);
  };
  
  useEffect(() => {
    if (location.pathname.split("/")[
      location.pathname.split("/").length - 1]) {
      const sections = document.querySelectorAll("section");

      sections.forEach((section) => {
        const titleElement = section.querySelector("p.api-key-section-title");

        if (
          titleElement &&
          titleElement.textContent.toLowerCase().replace(/\s+/g, "-") ===
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ]
        ) {
          section.scrollIntoView({ behavior: "smooth" });
          setScrollToSectionTitle(null);
        }
      });
    }
  }, [scrollToSectionTitle, location.pathname]);

  return (
    <>
      {showLoading ? (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#FFF",
          }}
        >
          <Loader />
        </div>
      ) : (
        <div
          ref={containerRef}
          style={{
            backgroundColor: "#FFF",
            height: "100%",
            borderRadius: "5px",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr) repeat(9, 1fr)",
            gap: "8px",
            position: "relative",
            padding: "5px",
            position: "relative",
          }}
        >
          <div
            style={{
              gridColumn: "span 3",
              position: "sticky",
              top: 0,
              height: "100%",
              overflow: "auto",
            }}
          >
            <ApiKeyAccordians accordData={accordData}  senderFun={handleCatchTitle} setActiveSection={setActiveSection} activeSection={activeSection} />
          </div>
          <div
            ref={parentRef}
            style={{
              gridColumn: "span 9",
              height: "100%",
              overflow: "auto",
            }}
          >
            {accordData.map((acc) =>
              acc.details.map((detailObj) => (
                <section
                  key={detailObj.id}
                  id={detailObj.text.toLowerCase().replace(/\s+/g, "-")}
                  style={{
                    padding: "12px 0px",
                    borderBottom: detailObj.border === undefined && "1px solid #DDD",
                  }}
                  data-path={detailObj.title}
                  ref={(ref) => {
                    handleRef(detailObj.text.toLowerCase().replace(/\s+/g, "-"), ref);
                    sectionRef(ref);
                  }}
                >
                  <div
                    style={{
                      borderLeft:`${detailObj.text.toLowerCase().replace(/\s+/g, "-") === activeSection ? "#fc9630" : 'transparent'} 2px solid`,
                      paddingLeft: "4px",
                    }}
                  >
                    <p className="api-key-section-title">{detailObj.text}</p>
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gap: "16px",
                      gridTemplateColumns: "repeat(7, 1fr) repeat(5, 1fr)",
                    }}
                  >
                    <div style={{ gridColumn: "span 6" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: detailObj.headerHtml,
                        }}
                      />
                      {detailObj.queryParamsHtml != null && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: detailObj.queryParamsHtml,
                          }}
                        />
                      )}
                       <div style={{borderTop:'1px solid #000',marginTop:'10px',paddingTop:'10px'}}>
                        <p style={{fontSize:'15px',color:'#868686'}}>
                          {detailObj.description}
                        </p>
                       </div>
                    </div>
                    <div
                      style={{
                        gridColumn: "span 6",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      <ApiKeyCodeViewComponent
                        url={detailObj.urlString}
                        method={detailObj.method}
                        response={detailObj.responseString}
                      />
                    </div>
                  </div>
                </section>
              ))
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ApiDocumentation;
